<template>
  <div class="panel-simple">
    <div class="pb-4 row px-4">
      <div class="col-md-3" v-if="isOnlyDate">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <span><b>Fecha</b></span>
          <CustomDatePicker
            v-model="value.evaluationDate"
            :max-date="disabledDatesAfter"
            :min-date="
              lastEvaluationDate != undefined
                ? new Date(lastEvaluationDate)
                : null
            "
            :error="errors[0]"
            :custom-error-msg="errorMsgs['fecha']"
            :disabled="disabled"
            class="custom-datetime-picker-container custom-datetime-picker-container-grey"
            placeholder="DD/MM/YYYY"
            @onSelectedDate="onSelectedDate"
          />
        </ValidationProvider>
      </div>
      <div v-if="showIsSufficientFlag && !isOnlyDate" class="col-md-6">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <CustomRadioGroup
            v-model="value.enoughInformation"
            is-inline
            label="¿Información resulta suficiente?"
            name="radiosGeneralSufficient"
            :options="radioButtonsOptions"
            :error="errors[0]"
            :is-disabled="disabled"
            custom-error-msg="Favor de contestar si la información resulta suficiente para el proceso."
          />
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ValidationProvider } from 'vee-validate';
import CustomRadioGroup from '@/components/common/CustomRadio';
import ValidationMixin from '@/mixin/validation.mixin.js';
import academicYearService from '@/services/academicyear';

export default {
  name: 'GeneralInformationEligibility',
  mixins: [ValidationMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          evaluationDate: null,
          enoughInformation: null,
          academicYearId: null,
          academicYearDescription: '',
          isValid: false,
          academicYear: null,
        };
      },
    },
    showIsSufficientFlag: {
      type: Boolean,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    isOnlyDate:{
      type: Boolean,
      default: () => false,
    },
    lastEvaluationDate: {
      type: Date,
      default: () => null,
    },
    disabledDatesAfter: {
      type: Date,
      default: () => new Date(Date.now()),
    },
  },
  components: {
    CustomDatePicker,
    ValidationProvider,
    CustomRadioGroup,
  },
  data() {
    return {
      errorMsgs: {
        fecha: 'Fecha es requerida para completar el proceso. (23028)',
      },
      radioButtonsOptions: [
        { label: 'Si', value: true },
        { label: 'No', value: false },
      ],
    };
  },
  methods: {
    async onSelectedDate(date) {
      if (date) {
        const {
          data: response,
        } = await academicYearService.getAcademicYearForDate(date);
        this.value.academicYearId = response.id;
        this.value.academicYearDescription = response.description;
        this.value.academicYear = response.year;
      }
    },
  },
  mounted() {},
};
</script>
